import * as yup from "yup"; //yup es la librería de validación de los campos
const rifs = require("../assets/rif.json");

export const folioValidationSchema = yup.object({
  origen: yup
    .string()
    .oneOf(["ML","Coppel"], "Selecciona un origen válido")
    .required("Selecciona un origen"),
  folio: yup
    .string()
    .when("origen",{
      is: "ML",
      then: (schema) =>
        schema
          .matches(/^\d+$/, "El folio debe ser numérico para Mercado Libre")
          .required("El folio es obligatorio"),
      otherwise: (schema) =>
        schema
          .matches(/^[a-zA-Z0-9\-]+$/, "El folio solo puede contener letras, números y guiones")
          .required("El folio es obligatorio"),
    }),
  monto: yup
    .number()
    .typeError("El monto debe ser numérico")
    .required("El monto es requerido"),
});

export const DatosClienteValidationSchema = yup.object({
  personaFisica: yup.bool().required(),
  RFC: yup
    .string()
    .when("personaFisica", {
      is: true,
      then: yup
        .string()
        .required("El RFC es requerido")
        .matches(
          "^(([A-ZÑ&]{4})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\\d])|[3][01])([A-Z0-9]{3}))|" +
            "(([A-ZÑ&]{4})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\\d])|[3][0])([A-Z0-9]{3}))|" +
            "(([A-ZÑ&]{4})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\\d])([A-Z0-9]{3}))|" +
            "(([A-ZÑ&]{4})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3}))$",
          "El formato de persona fisica no es correcto"
        )
        .min(13, "Debe de tener 13 dígitos")
        .max(13, "Debe de tener 13 dígitos"),
      otherwise: yup
        .string()
        .required("El RFC es requerido")
        .matches(
          "^(([A-ZÑ&]{3})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\\d])|[3][01])([A-Z0-9]{3}))|" +
            "(([A-ZÑ&]{3})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\\d])|[3][0])([A-Z0-9]{3}))|" +
            "(([A-ZÑ&]{3})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\\d])([A-Z0-9]{3}))|" +
            "(([A-ZÑ&]{3})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3}))$",
          "El formato de persona moral no es correcto"
        )
        .min(12, "Mínimo debe tener 12 dígitos")
        .max(14, "Máximo 14 dígitos"),
    })
    .required("El RFC es requerido"),
  usoCFDI: yup.string().required("CFDI obligatorio"),
  razonSocial: yup
    .string()
    .matches(/^[A-ZÁÉÍÓÚÑ0-9.\s]+$/gm, "No tiene el formato correcto")
    .max(50, "El máximo de caracteres es de 50")
    .required("Razon Social obligatoria"),
  codigoPostal: yup
    .string()
    .required("Ingresa el código postal")
    .min(5, "El CP debe tener 5 dígitos")
    .max(5, "El CP debe tener 5 dígitos")
    .matches(/^\d+$/, "Sólo deben ser números"),
  estado: yup
    .string()
    .required("Selecciona el estado")
    .max(50, "Es demasiado largo"),
  ciudad: yup
    .string()
    .required("La ciudad es requerida")
    .max(75, "El nombre de la ciudad es demasiado largo"),
  colonia: yup
    .string()
    .max(50, "El nombre de la colonia es demasiado largo")
    .min(2, "El nombre de la colonia es demasiado corto"),
  calle: yup
    .string()
    .required("Este campo no puede ir vacío")
    .max(40, "El nombre de la calle es demasiado largo"),
  numeroExterior: yup
    .string()
    .required("Es requerido")
    .max(10, "Máximo 10 caracteres")
    .test("len", "No es válido", (val) => {
      // Es un número válido
      if (!isNaN(parseFloat(val)) && isFinite(val)) {
        return true;
      }
      // no es entero, verificar que sea 'sn'
      if (val && val.toLowerCase() === "sn") {
        return true;
      }
      return false;
    }),
  numeroInterior: yup
    .string()
    .max(8, "El número no debe sobrepasar los 8 caracteres"),
  RIF: yup
    .string()
    .required("El RIF es requerido")
    .test("rif", "Por favor ingresa un RIF válido", (val) => {
      for (let i = 0; i < rifs.length; i++) {
        if (rifs[i].Id === parseInt(val)) {
          return true;
        }
      }
    }),
  formaPago: yup.string().required("La forma de pago es requerida"),
});

export const emailValidationSchema = yup.object({
  email: yup
    .string()
    .required("El correo electrónico es requerido")
    .email("Ingresa un correo electrónico válido"),
});
